<script lang="ts">
    import WarningInline from './WarningInline.svelte';
    import { _ } from 'svelte-i18n';

    export let center: boolean = true;
    export let text: string;
</script>

<div class="container" class:center>
    <WarningInline {text} />
</div>

<style>
    .container {
        display: flex;
    }
    .center {
        padding: 7%;
        margin: 7%;
    }
</style>
